import React from 'react'

const Button = ({ name, onClick, icon, disabled }) => {
    return (
        <button className="button" onClick={onClick} disabled={disabled}>{name} {icon}</button>
    )
}

export default Button